import { Tooltip } from './Tooltip'

export { TooltipV2 } from './components/TooltipV2'
export { Tooltip }
export default Tooltip
